import styled from 'styled-components';
import { Text } from '@perch-labs/shrike';

export const SourceText = styled(Text)`
  color: ${props => props.theme.colors.content.secondary};
  margin: 0 24px 16px;
  opacity: ${props => props.theme.opacities.medium};
`;
